// Archivo de configuración global
export const APP_VERSION = '1.0.1';

// Stripe configuration
export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;